import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useGetUserInfo } from "src/api/auth";
import { ReactComponent as ExpireIcon } from "src/assets/icons/expired-plan.svg";
import { tokens } from "src/locales/tokens";
import { paths } from "src/pages/paths";
import Button from "../button";
import { Dialog, DialogClose, DialogContent } from "../dialog";
import Typography from "../typography";

function ExpirePlanModal({ open, closeModal }: { open: boolean; closeModal: () => void }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { data: userInfoData } = useGetUserInfo({ enabled: false });
	return (
		<div className="ReloadPrompt-container">
			<Dialog open={open}>
				<DialogContent className="flex flex-col items-center justify-center space-y-4 rounded-2xl">
					<div className="z-20 mx-auto -mt-12 flex size-20 items-center justify-center rounded-full bg-gray-300 p-6">
						<ExpireIcon />
					</div>
					<div className="flex flex-col items-center justify-center space-y-2 text-center">
						<Typography className="text-gray-800" variant="h4">
							{t(tokens.expirePlanModal.yourPlan)}
							<span className="text-destructive-100"> {t(tokens.expirePlanModal.hasExpired)}</span>
						</Typography>
						{userInfoData?.data.plan?.is_access_buy_plan && (
							<Typography className="text-gray-700" variant="bodyLG">
								{t(tokens.expirePlanModal.description)}
							</Typography>
						)}
					</div>
					<div className="mt-4 flex justify-evenly">
						<Button onClick={() => closeModal()} variant="ghost">
							Skip
						</Button>
						<DialogClose>
							<Button
								className="hover:bg-blue-600"
								onClick={() => {
									closeModal();
									void navigate(`${paths.dashboard.premiumPlan}?expire-plan=true`);
								}}
							>
								<Typography className="text-white" variant="h4">
									{t(tokens.expirePlanModal.viewPlans)}
								</Typography>
							</Button>
						</DialogClose>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}

export default ExpirePlanModal;
